// extracted by mini-css-extract-plugin
export default {"sobre":"Sobre_sobre__U64aB","flex":"Sobre_flex__Ztv+j","txtSobre":"Sobre_txtSobre__unnHi","imgSobre":"Sobre_imgSobre__Jeb+z","flutuar":"Sobre_flutuar__kS9Mp"};